// extracted by mini-css-extract-plugin
module.exports = {"hidden":"result_hidden__B3ZpY","textEmphasis":"result_textEmphasis__Gxaxx","resultArea":"result_resultArea__jQjAu"};